import {TabPositionSticky} from '../../../common/presentational/TabPositionSticky';
import {requestContext} from '../../../common/requestContext';
import {ScheduleTab} from '../../../design-system/organisms/ScheduleTab/ScheduleTab';
import {DayOfWeekLayout} from '../../../graphql/generated/types';
import {aggregateAndSendLog} from '../../../logging/aggregateAndSendLog';
import {useGetDayOfWeekEventLog} from '../hook/useGetDayOfWeekEventLog';
import {useGetDayOfWeekLayoutData} from '../hook/useGetDayOfWeekLayoutData';
import {useGetDayOfWeekQueryParams} from '../hook/useGetDayOfWeekQueryParams';

interface Props {
  dayId?: number;
  sortType?: string;
  tabId?: string;
  dayOfWeekLayout: DayOfWeekLayout;
}

export const DayOfWeekLayoutDayTab = ({...rest}: Props) => {
  const {dayList} = rest.dayOfWeekLayout;
  const layoutData = useGetDayOfWeekLayoutData(rest);
  const {currentDayItem} = layoutData;
  const {display, lang} = requestContext.requestInfo;
  const {isMobile, isWebView} = display;
  const {deviceLang} = lang;
  const {getQueryString} = useGetDayOfWeekQueryParams();
  const days = dayList.map(day => ({
    name: day.translateProperty?.name?.[deviceLang] ?? day.name,
    param: day.param,
    href: getQueryString({
      day_id: day.param,
      // 요일 변경 시 탭 메뉴 정보와 페이징 정보를 초기화 합니다.
      tab_id: undefined,
      sort_type: undefined,
      page: undefined,
    }).search,
  }));

  const eventLog = useGetDayOfWeekEventLog(rest);
  const handleDayChange = (selectedDayId: string) => {
    const changedDay = dayList.find(item => item.param === selectedDayId);
    if (!changedDay) return;

    aggregateAndSendLog({
      actionType: 'Event',
      actionName: '요일_클릭',
      click: {
        layer1: '요일',
        copy: changedDay.name,
      },
      customProps: {
        user_action: 'click',
        ...eventLog.getCustomProps(),
      },
    });
  };

  return (
    <TabPositionSticky depth={2} isMobile={isMobile} isWebView={isWebView}>
      <ScheduleTab
        days={days}
        activeParam={currentDayItem.param}
        onDayChange={handleDayChange}
      />
    </TabPositionSticky>
  );
};
